import { createReducer, on } from '@ngrx/store';
import { actionLanguagesSmsNotificationsSet } from 'src/app/core/store/languages/languages.actions';

export interface LanguagesState {
  code: string
}

const initialState: LanguagesState = {
  code: undefined,
};

export const languagesReducer = createReducer(
  initialState,
  on(actionLanguagesSmsNotificationsSet, (state, action) => {
    return {
      ...state,
      code: action.code,
    };
  }),
);
